import { KeyFunctionMap, RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { Item } from "src/util/types/dataModels/item"

//region Types

export interface ItemCollectionMethod extends KeyFunctionMap {
  getItemIds: () => Promise<Array<string>>
}

export type ItemDocument = RxDocument<Item, KeyFunctionMap>

export type ItemCollection = RxCollection<Item, KeyFunctionMap, ItemCollectionMethod>

//endregion

/**
 * Schema for item collections
 */
export const itemSchema: RxJsonSchema<Item> = {
  title: "Item schema",
  description: "Collection of all items",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    item_id: { type: "string", minLength: 1 },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    designation: { type: "string", maxLength: 256, minLength: 1 },
    main_image: { ref: "attachment", type: "string", maxLength: 36 },
    item_class: { ref: "item_class", type: "string", maxLength: 36 }, // UUID
    location: { type: "string", maxLength: 36 }, // UUID
    item_model: { ref: "item_model", type: "string", maxLength: 36 }, // UUID
    restricted_to_procedures: {
      type: "array",
      items: {
        type: "string",
      },
    },
    attachments: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "item_id", "designation", "item_class"],
  indexes: ["item_class", "location", "item_model"],
}

export const itemCollectionMethods: ItemCollectionMethod = {
  async getItemIds(this: ItemCollection): Promise<string[]> {
    const allDocs: ItemDocument[] = await this.find().exec()
    return allDocs.map((item) => item.item_id)
  },
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const itemCollectionCreator: RxCollectionCreator = {
  schema: itemSchema,
  statics: itemCollectionMethods,
}
